<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UBfdjP/tc-custom/9781479894888.jpg?1719927229010" alt="This image is the cover for the book Pillars of Cloud and Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pillars of Cloud and Fire
      </h1>
      <p class="bookDescription body article font2">
        <p>At the birth of the United States, African Americans were excluded from the newly-formed Republic and its churches, which saw them as savage rather than citizen and as heathen rather than Christian. Denied civil access to the basic rights granted to others, African Americans have developed their own sacred traditions and their own civil discourses. As part of this effort, African American intellectuals offered interpretations of the Bible which were radically different and often fundamentally oppositional to those of many of their white counterparts. By imagining a freedom unconstrained, their work charted a broader and, perhaps, a more genuinely American identity. In Pillars of Cloud and Fire, Herbert Robinson Marbury offers a comprehensive survey of African American biblical interpretation. <br/><br/><br/><br/><br/><br/>Each chapter in this compelling volume moves chronologically, from the antebellum period and the Civil War through to the Harlem Renaissance, the civil rights movement, the black power movement, and the Obama era, to offer a historical context for the interpretative activity of that time and to analyze its effect in transforming black social reality. For African American thinkers such as Absalom Jones, David Walker, Zora Neale Hurston, Frances E. W. Harper, Adam Clayton Powell, and Martin Luther King, Jr., the exodus story became the language-world through which freedom both in its sacred resonance and its civil formation found expression. This tradition, Marbury argues, has much to teach us in a world where fundamentalisms have become synonymous with “authentic” religious expression and American identity. For African American biblical interpreters, to be American and to be Christian was always to be open and oriented toward freedom.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herbert Robinson Marbury
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eab439ba